import { useCallback, useEffect, useRef } from 'react'
import { useAppDispatch, useAppSelector } from 'store/hooks'

import { getScreen } from './getScreen'
import {
  screenModeChangeSize,
  screenModeChangeDevice,
  screenModeReset,
} from './screenModeSlice'

// обновление состояния экрана при изменении размеров окна
export function ScreenMode(): JSX.Element {
  const dispatch = useAppDispatch()
  const screenMode = useAppSelector(state => state.screenMode)
  const screenRef = useRef(screenMode.screen)
  screenRef.current = screenMode.screen

  const handleWindowSizeChange = useCallback(() => {
    const newScreenWidth = window.innerWidth
    const newScreenHeight = window.innerHeight

    dispatch(
      screenModeChangeSize({
        screenHeight: newScreenHeight,
        screenWidth: newScreenWidth,
      }),
    )

    const newScreen = getScreen(newScreenWidth)
    if (newScreen !== screenRef.current) {
      dispatch(screenModeChangeDevice({ screen: newScreen }))
    }
  }, [dispatch])

  useEffect(() => {
    handleWindowSizeChange()

    window.addEventListener('orientationchange', handleWindowSizeChange)
    window.addEventListener('resize', handleWindowSizeChange)

    return () => {
      window.removeEventListener('orientationchange', handleWindowSizeChange)
      window.removeEventListener('resize', handleWindowSizeChange)
      dispatch(screenModeReset())
    }
  }, [dispatch, handleWindowSizeChange])

  return <></>
}
